<template>
  <div> 
    <b-nav pills align="center">
      <b-nav-item to="/dashboard/"  active-class="active" link-classes="setup-nav-item">Dashboard</b-nav-item>
      <b-nav-item to="/templates/"  active-class="active" link-classes="setup-nav-item">Templates</b-nav-item>
      <b-nav-item to="/event-types/"  active-class="active" link-classes="setup-nav-item">Event Types</b-nav-item>
      <b-nav-item to="/broadcasts/"  active-class="active" link-classes="setup-nav-item">Broadcasts</b-nav-item>
      <b-nav-item to="/event-stream/"  active-class="active" link-classes="setup-nav-item">Event Stream</b-nav-item>
      <b-nav-item to="/settings/"  active-class="active" link-classes="setup-nav-item">Settings</b-nav-item>
      <b-nav-item target="_blank" href="https://docs.ravenhub.io"  active-class="active" link-classes="setup-nav-item">Install/Help</b-nav-item>
    </b-nav>
    
  </div>
</template>

<script>

export default {
  name: 'SetupMenuNavComponent',
  mounted: function () {
    
  },
  data: function () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>

<style scoped>

.nav-item:active {
  background: none ;
}
.nav-item {
  margin-left: 5px;
  margin-right: 5px;
}
.setup-nav-item {
  color:#160038 ;
  background: none ;
}
.setup-nav-item.active {
  color:#160038 !important;
  background: none !important;
  border-bottom: 3px solid #160038 !important;
}
.setup-nav-item:hover {
  color:#160038c4 !important;
  background: none !important;
  border-bottom: 3px solid #160038c4 !important;
}
</style>

